import React, { useRef } from 'react';
import dynamic from 'next/dynamic';
import cx from 'clsx';
import useClickOutside from '../../util/useClickOutside';
import { CSSTransition } from 'react-transition-group';
import classes from './Dropdown.module.scss';

const SimpleBar = dynamic(() => import('simplebar-react'), { ssr: false });
const SelectItem = dynamic(() => import( '../SelectItem/SelectItem'), { ssr: false });

const TRANSITION_DURATION = 250;

export interface DropdownProps extends React.HTMLProps<HTMLDivElement> {
  opened?: boolean,
  noPrevent?: boolean,
  selectedIndexes?: number[],
  listHeight?: number,
  childList?: {
    isLink?: boolean,
    href?: string,
    target?: string,
    onClick?(arv0: any): void;
    children?: any;
  }[];
  hideTopBorder?: boolean,

  onClose?(argv0: any): void,
}

export default function Dropdown({
  className,
  opened = false,
  onClose = () => {
  },
  childList,
  listHeight = 200,
  children = null,
  selectedIndexes,
  noPrevent,
  hideTopBorder = false,
}: DropdownProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClose = (e?: MouseEvent | TouchEvent) => {
    if (!noPrevent) {
      e?.preventDefault();
      e?.stopPropagation();
    }
    wrapperRef.current?.blur();
    onClose(e);
  };

  useClickOutside(wrapperRef, handleClose);

  return (
    <CSSTransition
      in={opened}
      unmountOnExit
      timeout={TRANSITION_DURATION}
      classNames={classes}
    >
      <div
        className={cx(classes.dropdown, className)}
        onKeyDownCapture={event => {
          opened && event.stopPropagation();
          if (event.keyCode === 27) {
            handleClose();
          }
        }}
        ref={wrapperRef}
      >
        {!hideTopBorder && <div className={classes.topBorder} />}
        <SimpleBar
          className={classes.dropdownList}
          style={{ maxHeight: listHeight }}
        >
          {children || childList?.map((item, index) => (
            <SelectItem
              key={index}
              className={classes.selectItem}
              label={item.children}
              {...item}
              onClick={() => {
                if (item.onClick) {
                  item?.onClick(item);
                }
                onClose(item);
              }}
            />
          ))}
        </SimpleBar>
      </div>
    </CSSTransition>
  );
}

Dropdown.displayName = '@ioa/lablocator/SelectDropdown';
